// extracted by mini-css-extract-plugin
export default {"rating":"SL-z","numberOfStars":"TL-z","count":"UL-z","barGraphSpacing":"VL-z","barGraph":"WL-z"};